import React, {
  ChangeEvent,
  Dispatch,
  FC,
  SetStateAction,
  useEffect,
  useState,
} from "react";
import { Col, Image, notification, Row } from "antd";
import styles from "./uploadFile.module.css";
import { ActivityIndicator } from "../ActivityIndicator";
import { FileImageCoverProps } from "../Forms/ToolsIAForm/utils";
import { useAuth } from "../../hooks/useAuth";
import axios from "axios";
import { environment } from "../../configuration/environment";
import { useApolloClientContext } from "../Provider/ApolloClientContext";

export interface UploadFileImageProps {
  title: string;
  typeFile: string;
  className: string;
  folder: string;
  // Removed level prop, now uses context
  questionTypeId?: number | null | undefined;
  widthCover?: number;
  heightCover?: number;
  filenameCover?: FileImageCoverProps;
  urlImageCover?: string;
  loadingLoadImage?: boolean;
  image?: string;
  imageAnswers?: string[];
  index?: number;
  urlImageQuestion?: string;
  urlImageAnswers?: string[];
  setimageAnswers?: React.Dispatch<React.SetStateAction<string[]>>;
  handleImageQuestion?: (newImage: string) => void;
  setLoadingLoadImage?: React.Dispatch<React.SetStateAction<boolean>>;
  setUrlImageQuestion?: React.Dispatch<React.SetStateAction<string>>;
  setUrlImageAnswers?: React.Dispatch<React.SetStateAction<string[]>>;
  setfilenameCover?: Dispatch<SetStateAction<FileImageCoverProps>>;
  setUrlImageCover?: React.Dispatch<SetStateAction<string>>;
  handleImageAnswers?: (newImage: string, indexAnswer: number) => void;
}

export const UploadImageFile = ({
  title,
  typeFile,
  folder,
  className,
  // Removed level prop, now uses context
  questionTypeId,
  widthCover = 300,
  heightCover = 300,
  filenameCover,
  image,
  index,
  imageAnswers,
  loadingLoadImage,
  urlImageQuestion,
  urlImageAnswers,
  urlImageCover,
  setimageAnswers,
  setUrlImageCover,
  setfilenameCover,
  handleImageQuestion,
  handleImageAnswers,
  setLoadingLoadImage,
  setUrlImageQuestion,
  setUrlImageAnswers,
}: UploadFileImageProps) => {
  const { token } = useAuth();
  const { level } = useApolloClientContext();
  const [loading, setLoading] = useState(false);
  let actualIndex = index || 0;

  const sortInfo = async () => {
    setLoading(true);
    if (
      (typeFile === "quiz" || typeFile === "cover") &&
      image &&
      image.length > 0
    ) {
      const imageUrl = `${environment.urlImages}${folder}/${image}`;
      setUrlImageCover && setUrlImageCover(imageUrl);
      
      // Solo inicializar filenameCover si está completamente vacío
      if ((!filenameCover?.id || filenameCover.id === "") && (!filenameCover?.ext || filenameCover.ext === "")) {
        const fileNameParts = image.split('.');
        if (fileNameParts.length >= 2) {
          const ext = fileNameParts.pop() || '';
          const id = fileNameParts.join('.');
          setfilenameCover && setfilenameCover({ id, ext });
        }
      }
    }
    if (typeFile === "questions" && image && image.length > 0) {
        const url = `${environment.urlImages}${folder}/${image}`;
        setUrlImageQuestion && setUrlImageQuestion(url);
    }
    actualIndex = index || 0;
    if (
      typeFile === "answers" &&
      actualIndex >= 0 &&
      imageAnswers && // [file.id, file.id]
      urlImageAnswers // [url, url]
    ) {
      if (actualIndex >= 0 && image && image.length > 0) {
        const url = `${environment.urlImages}${folder}/${image}`;
        urlImageAnswers[actualIndex] = url;
        setUrlImageAnswers && setUrlImageAnswers([...urlImageAnswers]);
        // Ensure imageAnswers also has the filename when editing existing items
        if (setimageAnswers && imageAnswers) {
          if (!imageAnswers[actualIndex] && image) {
            imageAnswers[actualIndex] = image;
            setimageAnswers([...imageAnswers]);
          }
        }
      }
    }
    setLoading(false);
  };

  useEffect(() => {
    sortInfo();
  }, [image]); // Solo ejecutar cuando cambie image, no cuando cambien filenameCover

  useEffect(() => {}, [setLoading, loading]);

  const completeUpload = async (file: File) => {
    setLoading(true);
    try {
      const backendBaseUrl =
        (level === "primaria"
          ? environment.primariaGraphQLURL
          : environment.secundariaGraphQLURL
        ).replace(/\/graphql$/, "");
      const response = await axios.post(
        `${backendBaseUrl}/urlimage`,
        {
          folder,
          extension: file.type.split("/")[1],
        },
        {
          headers: {
            token,
          },
        }
      );

      let id: string = response.data.url
        .split("/")
        [response.data.url.split("/").length - 1].split("?X-Amz-Algorithm")[0]
        .split(".")[0];
      let ext: string = response.data.url
        .split("/")
        [response.data.url.split("/").length - 1].split("?X-Amz-Algorithm")[0]
        .split(".")[1];

      await axios.put(response.data.url, file, {
        headers: {
          "content-type": file.type,
        },
      });

      if (typeFile === "quiz" || typeFile === "cover") {
        setfilenameCover &&
          setfilenameCover({
            id,
            ext,
          });
        const newUrl = `${environment.urlImages}${folder}/${id}.${ext}`;
        setUrlImageCover &&
          setUrlImageCover(newUrl);
      }

      if (typeFile === "questions") {
        const url = `${environment.urlImages}${folder}/${id}.${ext}`;
        setUrlImageQuestion && setUrlImageQuestion(url);
        handleImageQuestion && handleImageQuestion(url);
      }

      // let actualIndex = index || 0;
      if (typeFile === "answers" && imageAnswers && urlImageAnswers) {
        if (actualIndex >= 0) {
          const filename = `${id}.${ext}`;
          const url = `${environment.urlImages}${folder}/${id}.${ext}`;
          imageAnswers[actualIndex] = filename;
          setimageAnswers && setimageAnswers([...imageAnswers]);
          urlImageAnswers[actualIndex] = url;
          setUrlImageAnswers && setUrlImageAnswers([...urlImageAnswers]);
        }
        handleImageAnswers &&
          handleImageAnswers(`${environment.urlImages}${folder}/${id}.${ext}` , actualIndex);
      }

      setTimeout(() => {
        setLoading(false);
      }, 2000);
    } catch (error: any) {
      setLoading(false);
      notification["error"]({
        message: "Error",
        description: "La imagen no pudo ser subida, por favor, reintente.",
        placement: "top",
        duration: 3,
      });
    }
  };

  const handleFileChange = async (e: ChangeEvent<HTMLInputElement>) => {
    if (!e.target.files || !e.target.files[0]) return;
    let file: File = e.target.files[0] as unknown as File;

    setLoading(true);
    if (file.size > 0) {
      await completeUpload(file);
    } else {
      notification["error"]({
        message: "Error",
        description: "La imagen no pudo ser subida, por favor, reintente.",
        placement: "top",
        duration: 3,
      });
    }

    setTimeout(() => {
      setLoading(false);
    }, 1000);
  };

  return (
    <div className={styles.container}>
      <label htmlFor={`url_${typeFile}`}>{title}</label>
      <input type="file" onChange={handleFileChange} />
      <p>Formato soportado: .jpeg/.jpg - Peso máximo: 5 MB</p>
      <Col
        style={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        {loading ? (
          <ActivityIndicator size="small" classSmall={styles.activity} />
        ) : typeFile === "questions" &&
          urlImageQuestion &&
          urlImageQuestion.length > 0 ? (
          <Row style={{ padding: 20 }}>
            <Image
              src={urlImageQuestion}
              width={widthCover}
              height={heightCover}
            />
          </Row>
        ) : (typeFile === "quiz" || typeFile === "cover") &&
          urlImageCover &&
          urlImageCover.length > 0 ? (
          <Row style={{ padding: 20 }}>
            <Image
              src={urlImageCover}
              width={widthCover}
              height={heightCover}
            />
          </Row>
        ) : typeFile === "answers" &&
          urlImageAnswers &&
          urlImageAnswers[actualIndex] &&
          urlImageAnswers[actualIndex] !== "" ? (
          <Row style={{ padding: 20 }}>
            <Image
              src={urlImageAnswers[actualIndex]}
              width={widthCover}
              height={heightCover}
            />
          </Row>
        ) : null}
      </Col>
    </div>
  );
};
